import React from "react";

import { StyledListHeaderItem, StyledListItemCellProps } from "./styled";

export type ListItemCellProps = StyledListItemCellProps;

export const ListItemCell: React.FC<ListItemCellProps> = ({
  children,
  ...rest
}) => {
  return <StyledListHeaderItem {...rest}>{children}</StyledListHeaderItem>;
};
